/**
 * /auth/view-as?token=...
 * Consumes a view-as token, swaps in the impersonation session, and lands on /me.
 */
import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ViewAsConsumePage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("Verifying admin preview…");

  useEffect(() => {
    const token = params.get("token");
    const target = params.get("target") || "/me";
    if (!token) {
      setStatus("Missing token");
      return;
    }
    (async () => {
      try {
        const res = await axios.post(`${API}/auth/view-as/consume`, { token });
        if (res.data?.session_token) {
          localStorage.setItem("session_token", res.data.session_token);
          localStorage.setItem("phygital_view_as", JSON.stringify({
            user_id: res.data.user_id,
            display_name: res.data.display_name,
            is_view_as: true,
            target,
          }));
        }
        setStatus(`Loading ${res.data?.display_name || "user"}'s ${target}…`);
        setTimeout(() => navigate(target), 600);
      } catch (err) {
        setStatus(err.response?.data?.detail || "Token invalid or expired");
      }
    })();
  }, [params, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin mx-auto text-gray-700 mb-3" />
        <p className="text-sm text-gray-600">{status}</p>
      </div>
    </div>
  );
}
